<main class="relative isolate min-h-full">
  <!-- Background Images -->
  <img 
    src="https://images.unsplash.com/photo-1545972154-9bb223aac798?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3050&q=80&exp=8&con=-15&sat=-75" 
    alt="" 
    class="absolute inset-0 -z-10 size-full object-cover object-top dark:hidden" />
  <img 
    src="https://images.unsplash.com/photo-1545972154-9bb223aac798?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=3050&q=80&exp=-20&con=-15&sat=-75" 
    alt="" 
    class="absolute inset-0 -z-10 hidden size-full object-cover object-top dark:block" />
  
  <!-- Content -->
  <div class="mx-auto max-w-7xl px-6 py-32 text-center sm:py-40 lg:px-8">
    <p class="text-base/8 font-semibold text-white">{{ errorCode }}</p>
    <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-white sm:text-7xl">
      {{ getErrorTitle() }}
    </h1>
    <p class="mt-6 text-pretty text-lg font-medium text-white/70 sm:text-xl/8">
      {{ errorMessage }}
    </p>
    <div class="mt-10 flex justify-center gap-4">
      <button 
        (click)="goToDashboard()"
        class="text-sm/7 font-semibold text-white hover:text-white/90 transition-colors duration-200">
        <span aria-hidden="true">&larr;</span> Zurück zum Dashboard
      </button>
      <button 
        (click)="goBack()"
        class="text-sm/7 font-semibold text-white hover:text-white/90 transition-colors duration-200">
        <span aria-hidden="true">&larr;</span> Zurück
      </button>
    </div>
  </div>
</main>
